import { ConfirmDialog } from "primereact/confirmdialog";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { Toast } from "primereact/toast";
import { useCallback, useEffect, useRef, useState } from "react";

import { DescontoCard } from "../../components/descontoCard";
import { IDesconto } from "../../model/descontos";
import descontosService from "../../services/descontosService";
import { BasicCardWrapper, GestaoConveniadosContainer } from "./styles";

const GET_DESCONTOS_ERROR_MESSAGE =
  "Ocorreu um erro ao obter os descontos. Por favor, tente novamente.";

export const ListagemDescontos = () => {
  const toast = useRef<Toast>(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [size, setSize] = useState(25);
  const [page, setPage] = useState(0);
  const [first, setFirst] = useState(0);
  const [descontos, setDescontos] = useState<Array<IDesconto>>();

  const getDescontos = useCallback(async () => {
    try {
      const requestParams = { filter: "", page, size };
      const response = await descontosService.getDescontos(requestParams);

      setTotalRecords(response.data.totalElements);
      setDescontos(response.data.content);
    } catch (error) {
      console.error("Erro ao obter descontos:", error);
      toast.current?.show({
        severity: "error",
        summary: "Erro",
        detail: GET_DESCONTOS_ERROR_MESSAGE,
        life: 3000,
      });
    }
  }, [page, size]);

  useEffect(() => {
    void getDescontos();
  }, [getDescontos]);

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setSize(event.rows);
    setPage(event.page);
    setFirst(event.first);
    window.scrollTo(0, 350);
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog />

      <GestaoConveniadosContainer>
        <h2 style={{ margin: "1.5rem 0" }}>Descontos</h2>

        <BasicCardWrapper>
          {Array.isArray(descontos) && descontos.length > 0 ? (
            descontos.map((desconto) => {
              return (
                <DescontoCard
                  key={desconto.id}
                  desconto={desconto.desconto}
                  descricao={desconto.descricao}
                  endereco={desconto.endereco}
                  imagem={desconto.imagem}
                  nome={desconto.nome}
                ></DescontoCard>
              );
            })
          ) : (
            <p
              style={{
                position: "absolute",
                left: "50%",
                width: "100%",
                textAlign: "center",
                transform: "translateX(-50%)",
              }}
            >
              Nenhum resultado foi encontrado
            </p>
          )}
        </BasicCardWrapper>
        <Paginator
          rows={size}
          first={first}
          totalRecords={totalRecords}
          rowsPerPageOptions={[25, 50, 75, 100]}
          onPageChange={onPageChange}
          style={{ marginTop: "1rem" }}
        />
      </GestaoConveniadosContainer>
    </>
  );
};
